import React from 'react'
import { observer } from 'mobx-react'
import './styles.sass'
import formatCurrency from 'utils/formatCurrency'
import prefix from 'utils/prefix'
import cx from 'classnames'

const infoLineModifiers = prefix('info-line--')

export default observer(function JobInfo ({ job }) {
  return (
    <div className="job-info">
      {job.years && job.years.length > 0 &&
        <InfoLine title="Years">
          {job.years.join(', ')}
        </InfoLine>
      }
      <InfoLine title="States">
        {job.states.join(', ')}
      </InfoLine>
      {job.amendedAmount > 0 &&
        <InfoLine title="Amended">
          {formatCurrency(job.amendedAmount)}
        </InfoLine>
      }
      {job.couponAmount > 0 &&
        <InfoLine title="Coupon Discount" purple>
          -{formatCurrency(job.couponAmount)}
        </InfoLine>
      }
      <InfoLine title="Total">
        {formatCurrency(job.total)}
      </InfoLine>
      <InfoLine title="Paid so far">
        {formatCurrency(job.paidAmount)}
      </InfoLine>
    </div>
  )
})

const InfoLine = ({ title, children, purple }) => (
  <div className={cx('info-line', infoLineModifiers({ purple }))}>
    <div className="info-line__title">{title}</div>
    <div className="info-line__text">{children}</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectDetails/JobInfo/index.jsx